import { ReactElement, Suspense } from 'react';
import { Control, Controller } from 'react-hook-form';
import classnames from 'classnames/bind';
import { Typography } from '@weareopenr/component-library';
import RadioButton from '../RadioButton';
import styles from './RadioButtonGroup.module.scss';
import { useLocation } from 'react-router-dom';

const cx = classnames.bind(styles);

export interface RadioButtonOptionProps {
  option: string;
  LogoComponent: React.ComponentType | React.LazyExoticComponent<React.ComponentType>;
  toolTipText: string;
  label: string;
}

const RadioButtonGroup = ({
  radioButtonGroupName,
  radioOptions,
  control,
}: {
  radioButtonGroupName: string;
  control: Control<any>;
  radioOptions?: RadioButtonOptionProps[];
}): ReactElement => {
  const location = useLocation();

  return (
    <Controller
      rules={{ required: 'Please choose a type' }}
      defaultValue={''}
      control={control}
      name={radioButtonGroupName}
      render={({ field, fieldState: { error } }) => {
        const isFullWidth = radioOptions.length === 2 && !location.pathname.includes('menu');

        return (
          <>
            <div role="radiogroup" className={cx('group', { 'group-fullwidth': isFullWidth })}>
              {radioOptions.map(({ option, LogoComponent, toolTipText, label }) => {
                return (
                  <RadioButton
                    key={label}
                    isSelected={field.value === option}
                    name={radioButtonGroupName}
                    value={option}
                    label={label}
                    toolTipText={toolTipText}
                    hideRadio={true}
                    onChange={field.onChange}
                    logo={
                      <Suspense fallback={<></>}>
                        <LogoComponent />
                      </Suspense>
                    }
                    error={error}
                  />
                );
              })}
            </div>
            {error && <Typography className={styles['error-text']}>{error.message}</Typography>}
          </>
        );
      }}
    />
  );
};

export default RadioButtonGroup;
